import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PageviewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pageview"}/>
}
